module.exports = __webpack_public_path__ + "img/check-big.7db82d92.svg";